<template>
    <div class="row">
      <div class="col">
      <h4 class="mt-4">There has been an error on this page. We apologize for the inconvenience.</h4><br>
      </div>
    </div>
</template>